export default "__VITE_ASSET__McuRCR6N__"